export const getLocationsUrl = () => '/business/locations';

export const getLocationUrl = (id: string = ':id') => `/business/locations/${id}`;

export const getConcurrencySettingsUrl = () => '/business/locations/concurrency_settings';
